// file: ItemsList.component.tsx

import React from 'react';
// import reference to our interface
import {JobInterface} from '../../models/jobs/Job.interface';
// import reference to your Item component:
import {JobComponent} from './children/Job.component';
// import a reference to our Loader component:
import {Loader} from '../shared/Loader.component';

// ItemsList component
export class JobsListComponent extends React.Component<{
  loading: boolean;
  items: JobInterface[];
}> {
  render(): React.ReactNode {
    const {loading, items} = this.props;

    let element;
    if (loading) {
      // render Loader
      element = <Loader />;
    } else {
      // render <ul>
      element = (
        <ul className="job_bullets">
          {items.map((item, index) => {
            return <JobComponent key={index} model={item}></JobComponent>;
          })}
        </ul>
      );
    }

    return <div>{element}</div>;
  }
}
